import(/* webpackMode: "eager", webpackExports: ["GlobalChatStateProvider"] */ "/vercel/path0/app/chat/[avatarId]/hooks/useGlobalChatState.tsx");
